import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { wishlistAPI } from "../services/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) {
      setItems([]);
      return;
    }
    try {
      const data = await wishlistAPI.list();
      setItems(data);
    } catch (e) {
      console.warn("wishlist refresh failed", e);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const toggle = async (productId) => {
    if (!user) {
      const err = new Error("LOGIN_REQUIRED");
      err.code = "LOGIN_REQUIRED";
      throw err;
    }
    const { wished } = await wishlistAPI.toggle(productId);
    if (wished) {
      // refresh to get full product info
      refresh();
    } else {
      setItems((prev) => prev.filter((p) => p.id !== productId));
    }
    return wished;
  };

  const isWishlisted = (productId) => items.some((p) => p.id === productId);

  return (
    <WishlistContext.Provider value={{ items, refresh, toggle, isWishlisted }}>
      {children}
    </WishlistContext.Provider>
  );
}

export function useWishlist() {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error("useWishlist must be used within WishlistProvider");
  return ctx;
}
